import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PRIMARY_DOMAINS = [
  'dev.vizualx.pro',
  'vizualx.pro',
  'localhost'
];

// Matches /banner/ANYTHING  (project code is required)
const BANNER_PATTERN = /^\/banner\/[^/]+$/;

export default function CustomDomainGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const hostname = window.location.hostname;

  const isCustomDomain = !PRIMARY_DOMAINS.includes(hostname);

  useEffect(() => {
    if (!isCustomDomain) return;

    const path = location.pathname;

    // Allow only banner routes + static assets + error page
    const allowed =
      BANNER_PATTERN.test(path) ||
      path.startsWith('/assets/') ||
      path.startsWith('/js/') ||
      path.startsWith('/css/') ||
      path.startsWith('/fonts/') ||
      path.startsWith('/images/') ||
      path === '/favicon.ico' ||
      path === '/favicon.png' ||
      path === '/vite.svg' ||
      path === '/error';

    if (!allowed) {
      navigate('/error', { replace: true });
    }
  }, [location.pathname, isCustomDomain, navigate]);

  return children;
}
